import { useAppDispatch, useAppSelector } from 'common/hooks/redux';
import { fetchAppointmentById } from 'applicaiton/store/reducers/Appointments/ActionCreators';

/**
 * Custom hook to manage appointment state.
 * @returns An object containing current appointment,
 * function to fetch an appointment by id and a loading status.
 */
export const useAppointment = () => {
  const dispatch = useAppDispatch();
  const { currentAppointment, isLoading } = useAppSelector(
    (state) => state.appointmentsSlice,
  );

  /**
   * Function to fetch an appointment by id.
   * @param id - The id of the appointment to be fetched.
   */
  const fetchAppointment = async (id: number | string) => {
    dispatch(fetchAppointmentById(String(id)));
  };

  return {
    currentAppointment,
    fetchAppointmentById: fetchAppointment,
    isLoading,
  };
};
